import {useEffect} from 'react'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import {usePageActions, usePageStateSelector} from '../../../hooks/state'
import {usePrevious} from '../../../../../../commons/hooks/use-previous'
import {isReservationUnavailable} from '../../../selectors/reservation'

export const useCheckoutUnavailableCheck = () => {
  const {isEditor} = useEnvironment()
  const {openCheckoutUnavailable} = usePageActions()
  const reservationUnavailable = usePageStateSelector(isReservationUnavailable)
  const prevReservationUnavailable = usePrevious(reservationUnavailable)
  useEffect(() => {
    if (prevReservationUnavailable !== reservationUnavailable && reservationUnavailable && !isEditor) {
      openCheckoutUnavailable()
    }
  }, [isEditor, reservationUnavailable, prevReservationUnavailable, openCheckoutUnavailable])
}
